import { render, staticRenderFns } from "./knowledgeTable.vue?vue&type=template&id=da3f83d0&scoped=true"
import script from "./knowledgeTable.vue?vue&type=script&lang=js"
export * from "./knowledgeTable.vue?vue&type=script&lang=js"
import style0 from "./knowledgeTable.vue?vue&type=style&index=0&id=da3f83d0&prod&lang=less"
import style1 from "./knowledgeTable.vue?vue&type=style&index=1&id=da3f83d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3f83d0",
  null
  
)

export default component.exports